import {Component, Input, OnInit} from '@angular/core';
import {FormGroup, Validators} from '@angular/forms';
import {translate} from '@ngneat/transloco';

@Component({
  selector: 'signup-approvals-checks',
  templateUrl: './approvals-checks.component.html',
  styleUrls: ['./approvals-checks.component.scss'],
})
export class ApprovalsChecksComponent implements OnInit {
  @Input() public formGroupRef: FormGroup;
  @Input() public isGroup = false;

  constructor() {
  }

  get cguTextParts(): string[] {
    if (this.isGroup) {
      return translate(
        "Je confirme avoir pris connaissance et accepter les <a>Conditions Generales d'Utilisation</a> et accepte le <a>traitement de mes Donnees Personnelles</a> pour la creation de mon Organisation."
      ).split(/<\/*a>/g);
    }
    return translate(
      "Je confirme avoir pris connaissance et accepter les <a>Conditions Generales d'Utilisation</a> et accepte le <a>traitement de mes Donnees Personnelles</a> pour la creation d'un compte utilisateur."
    ).split(/<\/*a>/g);
  }

  get languageCode(): string {
    return window['CONST_LANG']['longcode'] ?? 'fr_FR';
  }

  ngOnInit(): void {
    this.formGroupRef.get('cgu_acceptance').setValidators(Validators.requiredTrue);
  }
}
